<template>
  <div class="background_img">
    <img
      v-if="loginPageInfo.bg_img"
      :src="loginPageInfo.bg_img"
      alt=""
      style="width: 100%"
    />
    <img v-else src="@/assets/images/backgroundImg.png" alt="" />
  </div>
  <div class="login_position">
    <div class="login_box">
      <div class="login_logo">
        <img v-if="loginPageInfo.logo" :src="loginPageInfo.logo" alt="" />
        <img v-else src="@/assets/images/logo.png" alt="" />
      </div>
      <div class="loginFunc_tab">
        <div class="loginFunc">
          <div
            id="lbAppText"
          >
            账号登录
          </div>
          <!-- <div
            id="lbApp"
            :class="status.loginFuncStatus ? 'active' : ''"
            @click="lbAppShow()"
          >
            账号登录
          </div> -->
          <!-- <div
            id="lbNormal"
            :class="!status.loginFuncStatus ? 'active' : ''"
            @click="lbNormalShow()"
          >
            扫码登录
          </div> -->
        </div>
        <!-- 二维码 -->
        <div class="appLoginTab" v-if="!status.loginFuncStatus">
          <i class="ico-login-switch-tips"></i>
          <div id="appCodeBox">
            <img id="appCode" src="@/assets/images/getUrlQrcode.jpg" />
          </div>
          <div class="u-scan-tips">微信扫码登录</div>
        </div>
        <!-- 用户密码 -->
        <div class="normalLoginTab loginForm" v-if="status.loginFuncStatus">
          <i class="ico-login-switch-tips"></i>
          <div class="loginUrs">
            <el-form ref="ruleFormRef" :model="formData" :rules="rules">
              <div class="urs">
                <el-form-item prop="urs">
                  <el-input
                    v-model="formData.urs"
                    class="ursval_input"
                    placeholder="请输入账号"
                    @keydown.enter="loginSubmit(ruleFormRef)"
                  />
                </el-form-item>
                <div class="ursicon">
                  <img src="@/assets/images/ico-user.png" alt="" />
                </div>
              </div>
              <div class="passwords">
                <el-form-item prop="password">
                  <el-input
                    v-model="formData.password"
                    :type="status.eyeSwitchStatus ? 'password' : ''"
                    class="ursval_input"
                    placeholder="请输入密码"
                    @keydown.enter="loginSubmit(ruleFormRef)"
                  />
                </el-form-item>
                <div class="ursicon">
                  <img src="@/assets/images/ico-password.png" alt="" />
                </div>
                <div class="eyeicon" @click="eyeSwitch">
                  <img
                    src="@/assets/images/ico-eye-off.png"
                    v-show="status.eyeSwitchStatus"
                  />
                  <img
                    src="@/assets/images/ico-eye.png"
                    v-show="!status.eyeSwitchStatus"
                  />
                </div>
              </div>
            </el-form>
            <!-- 提示 -->
            <div class="m-nerror" id="nerror" v-show="status.nerror">
              <div class="ferrortail"></div>
              <div class="ferrorhead"></div>
            </div>
            <div class="record">
              <!-- <label> <input type="checkbox" /> <span>记住账号</span> </label> -->
              <el-checkbox v-model="status.remember">记住账号</el-checkbox>
              <el-checkbox
                v-model="status.isDomain"
                v-if="loginPageInfo.is_domain == '1'"
                >域登录</el-checkbox
              >
            </div>
            <div class="login_btn" @click="loginSubmit(ruleFormRef)">登录</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="filings_number">
    <!-- <a target="_blank" href="http://beian.miit.gov.cn">{{ loginPageInfo.icp ? loginPageInfo.icp : '湘ICP备18009856号-2'}}
      <p>版权</p>
    </a> -->
    <a target="_blank" href="http://beian.miit.gov.cn"
      >{{ loginPageInfo.icp }}
      <p>{{ loginPageInfo.copyright }}</p>
    </a>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import { ElMessageBox } from "element-plus";
import api from "@/api/index";
onMounted(() => {
  if (window.localStorage.getItem("loginInfo")) {
    let loginInfo = JSON.parse(window.localStorage.getItem("loginInfo"));
    if (loginInfo) {
      formData.urs = loginInfo.urs;
      formData.password = loginInfo.password;
    }
  }
  getLoginPage();
});
let status = reactive({
  loginFuncStatus: true,
  remember: true,
  isDomain: true,
  eyeSwitchStatus: true,
  nerror: false,
});
let nerrorText = ref(null);
let eyeSwitchImg = ref("");
let formData = reactive({
  urs: "",
  password: "",
});
let ursVerify = (rule, value, callback) => {
  if (status.nerror) {
    callback(new Error(""));
  } else {
    callback();
  }
};
let passwordVerify = (rule, value, callback) => {
  if (status.nerror) {
    callback(new Error(nerrorText));
  } else {
    callback();
  }
};

const rules = reactive({
  urs: [
    { required: true, message: "账号不能为空！", trigger: "blur" },
    { required: true, validator: ursVerify, trigger: "blur" },
  ],
  password: [
    { required: true, message: "密码不能为空！", trigger: "blur" },
    { required: true, validator: passwordVerify, trigger: "blur" },
  ],
});

const ruleFormRef = ref(null);
// 账号登录
const lbAppShow = () => {
  status.loginFuncStatus = true;
};
// 扫码登录
const lbNormalShow = () => {
  status.loginFuncStatus = false;
};
// 查看密码
const eyeSwitch = () => {
  status.eyeSwitchStatus = !status.eyeSwitchStatus;
};

let loginPageInfo = ref("");
const getLoginPage = async () => {
  let res = await api.getLoginPage();
  // console.log("首页信息", res.data);
  if (res.data.code == "0") {
    let info = res.data.data;
    loginPageInfo.value = info;
    document.title = info.title ? info.title : "资管云";
  } else {
  }
};

// 提交登录
const loginSubmit = async (formEl) => {
  // console.log(formData);
  status.nerror = false;
  await formEl.validate((valid, fields) => {
    if (valid) {
      // 记住密码
      let loginInfo = "";
      if (status.remember) {
        loginInfo = JSON.stringify(formData);
      }
      window.localStorage.setItem("loginInfo", loginInfo);
      accountLogin();
    }
  });
};

// 管理员
const accountLogin = async () => {
  let isDomainData = "";
  let hrefUrl = "/adminfront/index/#/";
  if (loginPageInfo.value.is_domain == "1") {
    isDomainData = status.isDomain ? "1" : "0";
  }
  let res = await api.postAccountLogin({
    user_name: formData.urs,
    user_pwd: rsa_encode(formData.password),
    is_domai: isDomainData,
    pwd_type: 'rsa'
  });
  // console.log("登录信息", res.data);
  let resData = res.data;
  if (resData.code == "0") {
    if (resData.data) {
      window.localStorage.setItem("accessToken", resData.data.access_token);
      if (resData.data.index_page) {
        hrefUrl = resData.data.index_page;
      }
      if (resData.data.force_show) {
        ElMessageBox.alert(resData.data.force_show, "提示", {
          confirmButtonText: "好的",
          callback: () => {
            window.location.href = hrefUrl;
          },
        });
      } else {
        window.location.href = hrefUrl;
      }
    } else {
      window.location.href = hrefUrl;
    }
  } else {
    status.nerror = true;
    nerrorText = res.data.message;
    ruleFormRef._value.validate((valid, fields) => {});
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #000;
}
/deep/ .el-input__inner {
  -webkit-box-shadow: inset 0 0 0 1000px #fff !important;
  color: #333;
}
</style>